
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import moment from 'moment';
import {
  Operation, PermissionCode, User,
} from '@/types';
import EditLeadSupplyDialog from '@/components/EditLeadSupplyDialog.vue';

moment.locale('it');

@Component({
  components: {
    EditLeadSupplyDialog,
  },
})
export default class OperationTargetDate extends Vue {
  @Prop(Object) readonly operation!: Operation;

  editDialog = false

  loading = false

  targetDateNotes: string | null = null
  getTargetDateNotesTimeout: number | undefined

  @Watch('editDialog')
  onEditDialogChange(val: boolean) {
    if (val === false) {
      this.$nextTick(() => {
        (this.$refs.tippyRef as any).tippy().hide();
      });
    }
  }

  @Watch('amIUpdating')
  onAmIUpdatingChange(val: boolean, oldVal: boolean) {
    // console.log(`OperationLead: onAmIUpdatingChange() val = ${val} oldVal ${oldVal}`);
    if (oldVal === true && val === false) {
      // La commessa è stata aggiornata
      // Se sono stati scaricati in precedenza dei dettagli...
      if (this.targetDateNotes) {
        // ... recupero la nuova versione dei contatti
        this.getTargetDateNotes();
      }
    }
  }

  get poolUpdating(): { [key: number]: boolean } {
    return this.$store.getters.currentOperationsPoolUpdating;
  }

  get amIUpdating(): boolean {
    return this.operation
      && this.operation.id in this.poolUpdating
      && this.poolUpdating[this.operation.id] === true;
  }

  get hasTargetDateNotes(): boolean {
    return this.operation?.hasTargetDateNotes === true;
  }

  get targetDate(): string | null {
    return this.operation
      && this.operation.targetDate
      && moment(this.operation.targetDate).isValid()
      ? moment(this.operation.targetDate).format('L')
      : null;
  }

  get targetReminder(): boolean {
    return this.operation
      && 'targetReminder' in this.operation
      && this.operation.targetReminder === true;
  }

  get isEditable() {
    if (!this.operation) return false;

    // Se l'utente non ha accesso alla lead padre, non può modificare la data obiettivo
    if (!this.isCurrentUserAllowed) return false;

    return this.operation
      && 'status' in this.operation
      && (this.operation.status === 'open' || this.operation.status === 'new')
      && this.hasPermission('supply.edit');
  }

  get operationAllowedUsers(): number[] {
    return this.operation.allowedUsers.substring(1, this.operation.allowedUsers.length - 1).split(':')
      .map((s: string) => Number(s));
  }

  get isCurrentUserAllowed(): boolean {
    return this.operationAllowedUsers.includes(this.user.id);
  }

  async getTargetDateNotes() {
    try {
      const targetDateNotes = await this.$store.dispatch('getTargetDateNotes', { id: this.operation.id });

      if (targetDateNotes) {
        this.targetDateNotes = targetDateNotes.replace('\n', '<br>');
      }
    } catch (error) {
      console.log('OperationTargetDate: error =', error); // eslint-disable-line no-console
    }

    return Promise.resolve();
  }

  async onEdit() {
    this.loading = true;

    await this.$store.dispatch('selectLead', { id: this.operation.id });

    this.$nextTick(() => {
      (this.$refs.tippyRef as any).tippy().hide();
    });

    this.editDialog = true;

    this.loading = false;
  }

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get userPermissions(): PermissionCode[] {
    return this.$store.getters.currentUserPermissions;
  }

  hasPermission(codename: PermissionCode) {
    if (!this.user) return false;
    if (this.user.isSuperUser) return true;

    return this.userPermissions.includes(codename);
  }

  onTooltipShow() {
    console.log('OperationTargetDate: onTooltipShow()'); // eslint-disable-line no-console

    if (!this.hasTargetDateNotes || this.targetDateNotes) return;

    this.getTargetDateNotesTimeout = setTimeout(async () => {
      console.log('OperationTargetDate: onTooltipShow() timeout!'); // eslint-disable-line no-console

      this.getTargetDateNotes();
    }, 1000);
  }

  onTooltipHide() {
    clearTimeout(this.getTargetDateNotesTimeout);
  }
}
